import React from 'react';

import { useAuth } from '../../../../../../../shared/hooks';
import { CreatorList as SharedCreatorList } from '../../../../../../shared/components/Filter';
import { useCalendar, useFilters } from '../../../../hooks';

const CreatorList = () => {
  const {
    user: { id: currentUserId },
  } = useAuth();

  const { users } = useCalendar();
  const { activeFilters, toggleFilter } = useFilters();

  return (
    <SharedCreatorList
      currentUserId={currentUserId}
      onToggle={(value) => toggleFilter({ type: 'creators', value })}
      selectedIds={activeFilters.creators}
      users={users}
    />
  );
};

export default CreatorList;
